import index from './badge'

export default index